import { unityColorTokens } from '../../unityTokens';
import { ChronosphereColor } from './types';

export const unityGreen: ChronosphereColor = {
  50: unityColorTokens['--color-green-50'],
  100: unityColorTokens['--color-green-100'],
  150: unityColorTokens['--color-green-200'],
  200: unityColorTokens['--color-green-300'],
  300: unityColorTokens['--color-green-400'],
  400: unityColorTokens['--color-green-500'],
  500: unityColorTokens['--color-green-600'],
  600: unityColorTokens['--color-green-700'],
  700: unityColorTokens['--color-green-800'],
  800: unityColorTokens['--color-green-900'],
  850: unityColorTokens['--color-green-950'],
  900: unityColorTokens['--color-green-1000'],
  950: unityColorTokens['--color-green-1000'],
};

export const green: ChronosphereColor = {
  50: '#EAF9F1',
  100: '#D5F2E3',
  150: '#C1ECD4',
  200: '#ACE5C6',
  300: '#82D9AA',
  400: '#59CC8D',
  500: '#2CB46B',
  600: '#2D8658',
  700: '#1A6A42',
  800: '#145238',
  850: '#0E3922',
  900: '#092617',
  950: '#05130B',
};
